import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, renderSlot as _renderSlot, Teleport as _Teleport, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4ee48a88")

_pushScopeId("data-v-4ee48a88")
const _hoisted_1 = { class: "flex-1" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center gap-x-2"
}
const _hoisted_3 = {
  key: 0,
  class: "ml-2 rounded-full bg-red-lp-50 px-2 py-0.5 text-10px text-red-lp-100 font-semibold"
}
const _hoisted_4 = { class: "border-b p-3 border-gray-lp-1400 font-bold text-xs" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode("button", {
      class: ["flex w-full bg-amber-100 pr-3 group font-montserrat", [
        _ctx.active && !_ctx.data.children?.length
          ? 'bg-red-lp-1300 text-red-lp-2000 font-semibold'
          : 'text-black-lp-200 hover:bg-gray-lp-200 hover:text-gray-lp-300'
      ]],
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args))),
      ref: "triggerBtn"
    }, [
      _createVNode("div", {
        class: ["rounded-r-xl bg-transparent group-hover:bg-transparent mr-2", {
          'bg-transparent': !_ctx.active,
          'bg-red-lp-2000': _ctx.active && !_ctx.data.children?.length
        }],
        style: {"width":"5px"}
      }, null, 2),
      _createVNode("div", {
        class: ["flex items-center flex-grow", {
          'tree-item relative pl-3 ml-2.5': _ctx.tree,
          last: _ctx.last,
          'justify-between gap-x-2': !_ctx.isCollapsed,
          'justify-center': _ctx.isCollapsed
        }]
      }, [
        _createVNode("div", {
          class: ["flex items-center flex-1", {
            'gap-x-2 justify-between': !_ctx.isCollapsed,
            'justify-center': _ctx.isCollapsed
          }]
        }, [
          _createVNode("div", {
            class: ["flex items-center py-3", {
              'gap-x-2': !_ctx.isCollapsed
            }]
          }, [
            (_ctx.iconSrc)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  src: _ctx.iconSrc,
                  class: "w-5",
                  alt: _ctx.data.icon
                }, null, 8, ["src", "alt"]))
              : _createCommentVNode("", true),
            (!_ctx.isCollapsed)
              ? (_openBlock(), _createBlock("span", {
                  key: 1,
                  class: ["text-xs text-left", {
                'font-medium': !_ctx.active,
                'font-bold': _ctx.active || _ctx.open
              }]
                }, _toDisplayString(_ctx.data.label), 3))
              : _createCommentVNode("", true)
          ], 2),
          (!_ctx.isCollapsed)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                (_ctx.data?.is_notification && _ctx.showIconNotificationMenuSidebar)
                  ? (_openBlock(), _createBlock(_component_Icons, {
                      key: 0,
                      name: "bell",
                      fill: "",
                      class: "w-6 text-red-lp-2000"
                    }))
                  : _createCommentVNode("", true),
                _withDirectives(_createVNode("i", {
                  class: ["transition-all duration-300 pi text-red-lp-2000", _ctx.open ? 'pi-chevron-up' : 'pi-chevron-down']
                }, null, 2), [
                  [_vShow, _ctx.data.children?.length]
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2),
        (_ctx.data.is_new && !_ctx.isCollapsed)
          ? (_openBlock(), _createBlock("span", _hoisted_3, " New "))
          : _createCommentVNode("", true)
      ], 2)
    ], 2), [
      [_directive_tooltip, _ctx.isCollapsed ? _ctx.data.label : undefined]
    ]),
    (_ctx.showPopover && _ctx.isCollapsed && _ctx.data.children?.length)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "body"
        }, [
          _createVNode("div", {
            id: "sidebar-v2-sub-menu",
            class: "absolute z-50 w-56 rounded-lg shadow-lg bg-white border border-gray-lp-1400 flex flex-col pb-1 font-montserrat",
            style: {
          top: _ctx.popoverPos.top + 'px',
          left: _ctx.popoverPos.left + 'px',
          maxHeight: _ctx.maxHeight + 'px',
          overflowY: 'auto'
        }
          }, [
            _createVNode("span", _hoisted_4, _toDisplayString(_ctx.data.label), 1),
            _renderSlot(_ctx.$slots, "sub-menu", {
              close: () => (_ctx.showPopover = false)
            }, undefined, true)
          ], 4)
        ]))
      : _createCommentVNode("", true)
  ]))
})